import { useQueryAppointableCategoriesAsPublic } from "@gymflow/api";
import useGymflowModels from "apps/portal/src/store";
import { useTranslation } from "react-i18next";

import { LabeledForm } from "../../../atoms";
import { BadgePicker } from "../../../atoms/BadgePicker";
import { HostedPagesFilterPopover } from "../../components/HostedPagesFilterPopover";

export type HostedPagesProfileBookingAppointmentsFilterPopoverProps = {
  filter: {
    appointableCategoryId: number[];
  };
  onChange: (
    newFilter: HostedPagesProfileBookingAppointmentsFilterPopoverProps["filter"],
  ) => void;
};

export const HostedPagesProfileBookingAppointmentsFilterPopover = ({
  filter,
  onChange,
}: HostedPagesProfileBookingAppointmentsFilterPopoverProps) => {
  const { api } = useGymflowModels();
  const { t } = useTranslation();

  const { data: appointableCategories } = useQueryAppointableCategoriesAsPublic(
    {
      api,
      paginationOption: { page: 0, size: 200 },
      filter: {
        statusList: ["ACTIVE"],
      },
    },
  );

  return (
    <HostedPagesFilterPopover.Container>
      <HostedPagesFilterPopover.Trigger
        isFilterEmpty={filter.appointableCategoryId.length === 0}
      />
      <HostedPagesFilterPopover.Content>
        <HostedPagesFilterPopover.ContentHeader
          isFilterEmpty={filter.appointableCategoryId.length === 0}
          onReset={() => {
            onChange({
              appointableCategoryId: [],
            });
          }}
        />
        <div className="flex max-w-full p-4 pt-0">
          <LabeledForm
            label={t(
              "page.hostedPagesProfileBookingAppointments.hostedPagesProfileBookingAppointmentsFilterPopover.appointableCategory",
            )}
            className="gap-y-2"
          >
            <BadgePicker
              className="max-w-[80vw] lg:max-w-full"
              isMulti
              hasAllOption
              options={
                appointableCategories?.content.map((e) => ({
                  label: e.name,
                  value: e.id,
                })) ?? []
              }
              onChange={(newValue) => {
                onChange({
                  ...filter,
                  appointableCategoryId: newValue,
                });
              }}
              value={filter.appointableCategoryId}
            />
          </LabeledForm>
        </div>
      </HostedPagesFilterPopover.Content>
    </HostedPagesFilterPopover.Container>
  );
};
